module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktYm9yZGVyLWFsbCIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBkPSJNMCAwaDE2djE2SDBWMHptMSAxdjYuNWg2LjVWMUgxem03LjUgMHY2LjVIMTVWMUg4LjV6TTE1IDguNUg4LjVWMTVIMTVWOC41ek03LjUgMTVWOC41SDFWMTVoNi41eiIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/border-all.svg
// module id = BJ5a
// module chunks = 1